module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAACWTY9zAAAAAXNSR0IArs4c6QAAAHZJREFUSA1jfKOg8p+BCPCHjeWpjK+wNBFKqaKEiSqm0MCQUYeRGqijITYaYqSGAKnqWYjVwMrA+Od3zxFilVOsbjTxkxqEoyE2GmKkhgCp6gdtGiO6HPv97x8LIyMjqR4nW/2gDbFRh5Eap6MhNhpipIYAqeoBLe4LMF9r2yUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Uniited_Arab_Emirates.png
// module id = 495
// module chunks = 7